import React, { FC } from 'react'
import { IconButton } from '@wmgtech/legato'

import styles from './ActionButtons.module.scss'

interface ActionButtonsProps {
  isEditing: boolean
  isDisabled: boolean
  onEdit: () => void
  onCancel: () => void
  onSave: () => void
}

export const ActionButtons: FC<ActionButtonsProps> = ({ isEditing, onEdit, onCancel, onSave, isDisabled }) => {
  return isEditing ? (
    <div className={styles.container}>
      <IconButton className={styles.btn} message={'Cancel Edit'} colorType="danger" icon="xmark" onClick={onCancel} />
      <IconButton
        className={styles.btn}
        message={'Save Chart Source'}
        icon="check"
        colorType="success"
        onClick={onSave}
      />
    </div>
  ) : (
    <IconButton
      message={'Edit Chart Source'}
      disabled={isDisabled}
      icon="pen-to-square"
      colorType="secondary-black"
      onClick={onEdit}
    />
  )
}
